import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'


function addListeners_etron_s(frontCheckboxesMap, modalsCheckboxesMap) {
	
	const isRSModel = checkKey(frontCheckboxesMap, 'YTU')
	
	frontCheckboxesMap['YS1'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YS1',this.checked)
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YS1', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVE'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVE',this.checked)
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YVE', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVJ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVJ', this.checked)		
		//CheckModalVisibility START
		const modal = document.querySelectorAll('.modal')[0]
		if (this.checked) {
			modal.classList.remove("hidden")
		} else {
			modal.classList.add("hidden")
		}
		//CheckModalVisibility END
		if (this.checked) {
			if (!isRSModel) {
				activateConnectedPackages(["YSR"], frontCheckboxesMap);
			}
		} else {
			deactivateConnectedPackages(["YVU_etron", "YVQ_etronGT", "YSR", "YTU"], frontCheckboxesMap);
		}
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YVJ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YFA_etronGT'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFA_etronGT', this.checked)
		//CheckModalVisibility START
		const modal = document.querySelectorAll('.modal')[0]
		const modal_checkboxes = document.querySelectorAll('.modal-checkboxes')[0]
		if (this.checked) {
			syncCheckedStatesToModal(frontCheckboxesMap, modalsCheckboxesMap)
			modal.classList.remove("hidden")
			modal.classList.add("YFA_etronGT")
			modal_checkboxes.classList.add("YFA_etronGT")			
		} else {
			modal.classList.add("hidden")
			modal.classList.remove("YFA_etronGT")
			modal_checkboxes.classList.remove("YFA_etronGT")		
		}
		//CheckModalVisibility END
		if (this.checked) {
			activateConnectedPackages(["YS1", "YSJ"], frontCheckboxesMap);
			if (!isRSModel) {
				activateConnectedPackages(["YSR"], frontCheckboxesMap);
			}
		} else {
			deactivateConnectedPackages(["YS1", "YSJ", "YVU_etron", "YVQ_etronGT", "YSR", "YTU"], frontCheckboxesMap);
		}
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YFA_etronGT', frontCheckboxesMap)
	})

	frontCheckboxesMap['YFB_etronGT'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YFB_etronGT', this.checked)
		//CheckModalVisibility START
		const modal = document.querySelectorAll('.modal')[0]
		const modal_checkboxes = document.querySelectorAll('.modal-checkboxes')[0]
		if (this.checked) {
			syncCheckedStatesToModal(frontCheckboxesMap, modalsCheckboxesMap)
			modal.classList.remove("hidden")
			modal.classList.add("YFB_etronGT")
			modal_checkboxes.classList.add("YFB_etronGT")			
		} else {
			modal.classList.add("hidden")
			modal.classList.remove("YFB_etronGT")
			modal_checkboxes.classList.remove("YFB_etronGT")		
		}
		//CheckModalVisibility END
		if (this.checked) {
			activateConnectedPackages(["YVJ"], frontCheckboxesMap);
			if (!isRSModel) {
				activateConnectedPackages(["YSR"], frontCheckboxesMap);
			}
		} else {
			deactivateConnectedPackages(["YVJ", "YVU_etron", "YVQ_etronGT", "YSR", "YTU"], frontCheckboxesMap);
		}
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YFB_etronGT', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSJ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ', this.checked)
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YSJ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YVU_etron'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU_etron', this.checked);
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YVU_etron', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YVQ_etronGT'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVQ_etronGT', this.checked);
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YVQ_etronGT', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTQ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ', this.checked);
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YTQ', frontCheckboxesMap)
	})

	frontCheckboxesMap['YSR'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR', this.checked);
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YSR', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTU']?.addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTU', this.checked);
		checkLocks_etron_s(frontCheckboxesMap)
		getPackageImages_etron('YTU', frontCheckboxesMap)
	})

}

function clearAllModalCheckboxes() {
	document.querySelectorAll('.modal-checkboxes input[type="checkbox"]').forEach(checkbox => {
		checkbox.checked = false;
		checkbox.disabled = false;
		checkbox.parentElement.classList.remove('is-checked');
	});
}

function syncCheckedStatesToModal(frontCheckboxesMap, modalsCheckboxesMap) {
	Object.keys(frontCheckboxesMap).forEach(key => {
		if (modalsCheckboxesMap[key]) {
			modalsCheckboxesMap[key].checked = frontCheckboxesMap[key].checked;
			if (frontCheckboxesMap[key].checked) {
				modalsCheckboxesMap[key].click();
				modalsCheckboxesMap[key].parentElement.classList.add('is-checked');
				modalsCheckboxesMap[key].click();
			} else {
				modalsCheckboxesMap[key].parentElement.classList.remove('is-checked');
			}
		}
	});
}

function activateConnectedPackages(packageIds, frontCheckboxesMap) {
	packageIds.forEach(function (id) {
		if (frontCheckboxesMap[id] && !frontCheckboxesMap[id].checked) {
			frontCheckboxesMap[id].checked = true;
			saveStateWithAjax(id, true);
			frontCheckboxesMap[id].parentElement.classList.add('is-checked');
			getPackageImages_etron(id, frontCheckboxesMap);
		}
	});
}

function deactivateConnectedPackages(packageIds, frontCheckboxesMap) {
	packageIds.forEach(function (id) {
		if (frontCheckboxesMap[id]) {
			frontCheckboxesMap[id].disabled = false;
			frontCheckboxesMap[id].parentElement.classList.remove('is-checked');
			frontCheckboxesMap[id].checked = false;
			saveStateWithAjax(id, false);
			getPackageImages_etron(id, frontCheckboxesMap);
		}
	});
	clearAllModalCheckboxes()
}


/**Controls frontcheckboxes disable */
function checkLocks_etron_s(frontCheckboxesMap) {
	
	const isRSModel = checkKey(frontCheckboxesMap, 'YTU')

	//DEFINE UNLOCK CONDITIONS
	
	const unlockConditionForYS1 = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YFA_etronGT'].checked 
	const unlockConditionForYVE =  !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YFB_etronGT'].checked &&  !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YTQ'].checked && !frontCheckboxesMap['YSR'].checked && (isRSModel ? !frontCheckboxesMap['YTU']?.checked : true)	
	const unlockConditionForYVJ = !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YSR'].checked && !frontCheckboxesMap['YVE'].checked  && (isRSModel ? !frontCheckboxesMap['YTU']?.checked : true)
	const unlockConditionForYSJ =  !frontCheckboxesMap['YFA_etronGT'].checked
	const unlockConditionForYFA = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YVE'].checked
	const unlockConditionForYFB = !frontCheckboxesMap['YFA_etronGT'].checked && !frontCheckboxesMap['YS1'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YSR'].checked  && !frontCheckboxesMap['YVU_etron'].checked 
	const unlockConditionForYVU = !frontCheckboxesMap['YVQ_etronGT'].checked && !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked  && (isRSModel ? !frontCheckboxesMap['YTU']?.checked : true) && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YFA_etronGT'].checked
	const unlockConditionForYVQ_etronGT = !frontCheckboxesMap['YVU_etron'].checked && !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YVE'].checked && (isRSModel ? !frontCheckboxesMap['YTU']?.checked : true) && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YFA_etronGT'].checked
	const unlockConditionForYTQ = !frontCheckboxesMap['YVE'].checked
	const unlockConditionForYSR = !frontCheckboxesMap['YVJ'].checked && (isRSModel ? !frontCheckboxesMap['YTU']?.checked : true) && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YFA_etronGT'].checked 
	const unlockConditionForYTU = !frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YSR'].checked && !frontCheckboxesMap['YVE'].checked && !frontCheckboxesMap['YFB_etronGT'].checked && !frontCheckboxesMap['YFA_etronGT'].checked

	//UPDATE VARS 
	frontCheckboxesMap['YS1'].disabled = !unlockConditionForYS1
	frontCheckboxesMap['YVE'].disabled = !unlockConditionForYVE
	frontCheckboxesMap['YVJ'].disabled = !unlockConditionForYVJ
	frontCheckboxesMap['YSJ'].disabled = !unlockConditionForYSJ
	frontCheckboxesMap['YFA_etronGT'].disabled = !unlockConditionForYFA
	frontCheckboxesMap['YFB_etronGT'].disabled = !unlockConditionForYFB
	frontCheckboxesMap['YVU_etron'].disabled = !unlockConditionForYVU
	frontCheckboxesMap['YVQ_etronGT'].disabled = !unlockConditionForYVQ_etronGT
	frontCheckboxesMap['YTQ'].disabled = !unlockConditionForYTQ
	frontCheckboxesMap['YSR'].disabled = !unlockConditionForYSR
	if (isRSModel){
		frontCheckboxesMap['YTU'].disabled = !unlockConditionForYTU
	}

	// SPECIAL CASE
	//If YFB_etronGT is checked, then delete disabled
	if (frontCheckboxesMap['YFB_etronGT'].checked) {
		frontCheckboxesMap['YFB_etronGT'].disabled = false
	}
	// SPECIAL CASE
	//If YVJ is checked and YFB is unchecked, then delete disabled
	if (frontCheckboxesMap['YVJ'].checked && !frontCheckboxesMap['YFB_etronGT'].checked) {
		frontCheckboxesMap['YVJ'].disabled = false
	}
	// SPECIAL CASE
	//If YFA_etronGT is checked, then delete disabled
	if (frontCheckboxesMap['YFA_etronGT'].checked) {
		frontCheckboxesMap['YFA_etronGT'].disabled = false
		frontCheckboxesMap['YVU_etron'].disabled = true
		frontCheckboxesMap['YSR'].disabled = true
	}

}

/**Gets images for all packages depending on selected packages */
function getImages_etron_s(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_etron(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_etron(packageCode, checkboxesMap) {
	
	// Special case for YRB-YVJ AND YVN-YVJ
	if (checkboxesMap['YFA_etronGT'].checked) {
		if (packageCode == 'YRB-YVJ'){
			packageCode = 'YRB'
		} else if (packageCode == 'YVN-YVJ') {
			packageCode = 'YVU_etron'
		}
	} else {
		if (packageCode == 'YRB-YVJ' || packageCode == 'YVN-YVJ'){
			packageCode = 'YVJ'
		}
	}
	
	// Special case for YSR
	if (packageCode == 'YSR' && (checkboxesMap['YVJ'].checked || checkboxesMap['YFB_etronGT'].checked)) {
		packageCode = 'YVJ'
	}
	// Special case for YVU_etron and YVN
	if ((packageCode == 'YVU_etron' || packageCode == 'YVN') && (checkboxesMap['YVJ'].checked || checkboxesMap['YFB_etronGT'].checked)) {
		packageCode = 'YVJ'
	}
	// Special case for YFB_etronGT
	if (packageCode == 'YFB_etronGT') {
		packageCode = 'YVJ'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}

	updateBackgroundImage()

}


function updateBackgroundImage() {
	const isYVN_Checked = isCheckboxCheckedByAuiCode('YVN');
	const isYVU_Checked = isCheckboxCheckedByAuiCode('YVU_etron');
	const isYVJ_Checked = isCheckboxCheckedByAuiCode('YVJ');
	const isYFA_Checked = isCheckboxCheckedByAuiCode('YFA_etronGT');
	const isYFB_Checked = isCheckboxCheckedByAuiCode('YFB_etronGT');
	//Basisbild austauschen
	const model = document.querySelector("input[name='carmodel']").value;
	let modeltype = "";
	if (model == 1) {
		modeltype = 's_';
	} else if (model == 2 || model == 200) {
		modeltype = 'rs_';
	}
	if (isYVN_Checked) {
		document.getElementById("front_background_image").src = "img/01_interieur/paketauswahl/au513_" + modeltype + "e-tron_gt_paketauswahl_basislayer-yve.png";
		if (isYVJ_Checked) {
		if (isYFB_Checked) {	
			document.getElementById("YVJ-img").src = "img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_yvj_nahtpaket_lenkrad.png";
		} else {
			document.getElementById("YVJ-img").src = "img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_yvj_nahtpaket_12uhr_lenkrad.png";
		}}	
	} else if (isYVU_Checked) {
		document.getElementById("front_background_image").src = "img/01_interieur/paketauswahl/au513_" + modeltype + "e-tron_gt_paketauswahl_basislayer.png";
		if (isYVJ_Checked) {
			document.getElementById("YVJ-img").src = "img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_yvj_nahtpaket_lenkrad.png";
		}	
	} else {
		document.getElementById("front_background_image").src = "img/01_interieur/paketauswahl/au513_" + modeltype + "e-tron_gt_paketauswahl_basislayer.png";
		if (isYVJ_Checked) {
			document.getElementById("YVJ-img").src = "img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_yvj_nahtpaket_lenkrad.png";
		}	
	}
}

function isCheckboxCheckedByAuiCode(auiCode) {
	const label = document.querySelector(`label[data-auicode="${auiCode}"]`);
    if (label) {
        const checkbox = label.querySelector('input[type="checkbox"]');
        return checkbox ? checkbox.checked : false;
    }
    return false;
}

export { addListeners_etron_s, saveStateWithAjax, checkLocks_etron_s, getImages_etron_s, getPackageImages_etron, updateBackgroundImage}

